// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.fade-enter-active[data-v-0634d484],\n.fade-leave-active[data-v-0634d484] {\n  transition: opacity 0.5s;\n}\n.fade-enter[data-v-0634d484], .fade-leave-to[data-v-0634d484] /* .fade-leave-active below version 2.1.8 */ {\n  opacity: 0;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
